import { Component, Input } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { map } from 'rxjs/operators';
import { IOrderTask, OrderTaskService, Page } from 'src/app/xena-api';

@Component({
    selector: 'app-order-task-mapping',
    templateUrl: './order-task-mapping.component.html',
    styleUrls: ['./order-task-mapping.component.scss'],
    standalone: false
})
export class OrderTaskMappingComponent {
  @Input() orderTaskMappings: UntypedFormArray;

  constructor(private orderTaskService: OrderTaskService) { }

  orderTaskDatasource = (queryString: string): Promise<IOrderTask[]> =>
    this.orderTaskService.list({ queryString, forceNoPaging: false, contextType: 'ContextType_Customer' })
      .pipe(map((x: Page<IOrderTask>) => x.entities))
      .toPromise();

  orderTaskNumber(orderTask: IOrderTask): string {
    return (`${orderTask.orderTaskNumber} ${orderTask.description}`).trim();
  }

  orderTaskIcon(orderTask: IOrderTask): string {
    return !orderTask.isInvoiced ? null : 'fas-file-invoice'
  }
}
